<template>
  <div class="admin-multi-lang-links">
    <div class="text-center">
      <span>Links</span>
    </div>
    <div v-for="(item, i) in values" class="field width-100p mb-24 m-auto">
      <div class="flex-row flex-justify-around">
        <div class="width-400">
          <div class="flex-row flex-justify-between pl-8 mb-8">
            <div class="flex-1 mt-16 text-left pl-8">
              <label>Link Title (en)</label>
            </div>
            <span class="button btn-translate width-100 translate-to-ja">translate</span>
          </div>
          <input type="text" class="input translate-text" v-model="values[i].title_en" />
        </div>

        <div class="width-400">
          <div class="flex-row flex-justify-between pl-8 mb-8">
            <div class="flex-1 mt-16 text-left pl-8">
              <label>Link Title (ja)</label>
            </div>
            <span class="button btn-translate width-100 translate-to-en">translate</span>
          </div>
          <input type="text" class="input translate-text" v-model="values[i].title_ja" />
        </div>
      </div>
      <div class="width-400 m-auto">
        <div class="mt-8 text-left pl-8">
          <label>URL</label>
        </div>
        <input type="text" class="input" v-model="values[i].url" />
      </div>
    </div>

    <div class="width-100p m-auto text-right mt-16">
      <span class="button is-small" @click="addItem">Add</span>
    </div>
    <input type="hidden" :value="inputtedValues" :name="fieldName" />
  </div>
</template>

<script>
export default {
  props: {
    attributeName: String,
    fieldName: String,
    valuesJson: String,
  },

  data() {
    return {
      values: [{ 'title_en': '', 'title_ja': '', 'url': '' }],
    }
  },

  computed: {
    inputtedValues() {
      return JSON.stringify(this.values.filter(value => value.title_en && value.title_ja && value.url))
    },
  },

  methods: {
    setupAllTranslateEvents() {
      const buttons = this.$el.querySelectorAll('.btn-translate');
      buttons.forEach(button => this.setupTranslateEvent(button));
    },

    setupTranslateEvent(button) {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', () => {
        const translateType = Array.from(newButton.classList).find(name => name.startsWith('translate-to'));
        const currentField = newButton.closest('.field');
        const index = Array.from(this.$el.querySelectorAll('.field')).indexOf(currentField);

        // 翻訳の方向を決定
        const isJaTranslation = translateType === 'translate-to-ja';

        // 現在のフィールド内での翻訳元と翻訳先を特定
        const currentTitleContainer = newButton.closest('.width-400');
        const originalInput = currentTitleContainer.querySelector('.translate-text');

        // 同じfield内の別の.width-400を見つける
        const titleContainers = currentField.querySelectorAll('.width-400');
        const targetContainer = Array.from(titleContainers).find(container => container !== currentTitleContainer);
        const targetInput = targetContainer.querySelector('.translate-text');

        const targetLang = isJaTranslation ? 'ja' : 'en';

        if (originalInput.value) {
          const axios = require('axios');
          axios.post('/admin/translate', { text: originalInput.value, lang: targetLang })
            .then(response => {
              const targetField = isJaTranslation ? 'title_ja' : 'title_en';
              this.$set(this.values[index], targetField, response.data.text);

              targetInput.value = response.data.text;
            })
            .catch(error => {
              console.log('ERROR: translation failed', error);
            });
        }
      });
    },

    addItem() {
      this.values.push({ 'title_en': '', 'title_ja': '', 'url': '' });
      
      this.$nextTick(() => {
        this.setupAllTranslateEvents();
      });
    },
  },

  mounted() {
    try {
      if (JSON.parse(this.valuesJson).length > 0) {
        this.values = JSON.parse(this.valuesJson)
      }
    } catch (_error) {
      // console.log(error);
    }

    this.$nextTick(() => {
      this.setupAllTranslateEvents();
    });
  },
}
</script>

<style lang="scss" scoped>
</style>
